<template>
    <div class="w-full h-full px-2 md:px-4 lg:px-8 flex flex-row">
        <div v-if="!addModal" class="flex flex-row gap-x-4 w-full">
            <div class="pt-2 w-1/4 flex-none h-40 sticky rounded-lg">
                <div class="w-4/5 m-auto py-4 flex flex-col gap-y-4">
                    <p class="text-2xl dark:text-gray-300 text-gray-700">Adicionar Produto</p>
                    <span class="w-full md:flex-1">
                        <Autocomplete v-model="marca" label="Marca" placeholder="Selecionar marca" :list="marcas" desc="marca" @filter="filterModelos()"/>
                    </span>
                    <span class="w-full md:flex-1">
                        <Autocomplete :disabled="!marca" v-model="modelo" label="Modelo" placeholder="Selecionar modelo" @filter="filterComplementos()" :list="modelos" desc="descricao" />
                    </span>

                    <span class="w-full md:flex-1">
                        <p class="uppercase text-gray-300 text-xs"> </p>
                        <Input v-model="searchComplemento" label="Pesquisar complemento"/>
                    </span>
                </div>
            </div>
            <div id="lojas-section" class="w-3/4 flex-none flex flex-col flex-wrap gap-y-4 mt-2 overflow-y-scroll">
                <div v-if="!marca || !modelo" class="dark:text-gray-400 text-gray-500 dark:bg-gray-800 bg-gray-200 w-full h-auto rounded-lg flex flex-col items-center justify-center py-5 px-5">
                    <span class="text-5xl material-icons-outlined">
                        filter_alt
                    </span>
                    <p class="text-lg">Selecione {{!marca ? 'uma marca para iniciar a pesquisa' : 'um modelo'}} </p>
                </div>
                <div v-if="filteredListComplementos.length === 0 && modelo" class="dark:text-gray-400 text-gray-500 dark:bg-gray-800 bg-gray-200 w-full h-24 rounded-lg flex flex-col items-center justify-center py-2 px-5">
                    <p class="text-lg">Todos os produtos adicionados</p>
                </div>
                <span v-for="c, i in filteredListComplementos" :key="i" class="w-full">
                    <div class="dark:bg-gray-800 bg-gray-100 border border-gray-200 dark:border-gray-700 h-24 rounded-lg shadow-lg flex items-center px-4 gap-x-4">
                        <p class="text-base text-indigo-500">#{{c.id}}</p>
                        <span class="w-full">
                            <p class="text-gray-700 dark:text-gray-300 text-base">{{marca}} {{modelo}}</p>
                            <p class="text-gray-700 dark:text-indigo-200 text-xl">{{c.descricao}}</p>
                        </span>
                        <div class="">
                            <button class="btn text-indigo-500 text-sm uppercase" @click="addProduct(c.id)">Adicionar</button>
                        </div>

                    </div>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import Input from '@/components/Design/Input'
import Autocomplete from '@/components/Design/Autocomplete'
import Select from '@/components/Design/Select'
import { GET_SEGMENTOS, GET_MODELOS_BY_MARCA, GET_MARCAS_BY_SEGMENTO, POST_SEGMENTOS, POST_MARCAS, POST_MODELOS, POST_COMPLEMENTO, GET_COMPLEMENTOS_BY_MODELO, POST_PRODUTOS_LOJA, GET_PRODUTOS_BY_LOJA } from '../../mixins/api.js'
import { computed, onMounted, ref } from 'vue'
import useVuelidate from '@vuelidate/core'
import { findId } from '../../mixins/findData.js'
import { displayNotification } from '../../mixins/notification.js'
export default {
    name: 'NovaLoja',
    components: {
        Input,
        Select,
        Autocomplete
    },
    props: ['loja'],
    setup (props) {
        const segmentos = ref([])
        const segmento = ref('')
        const marcas = ref([])
        const marca = ref('')
        const modelos = ref([])
        const modelo = ref('')
        const complemento = ref('')
        const complementos = ref([])
        const searchComplemento = ref('')

        const filterModelos = async () => {
            if (marca.value === '') {
                modelo.value = ''
                modelos.value = []
                complemento.value = ''
                complementos.value = []
            } else {
                const id = findId(marcas.value, marca.value, 'marca')
                await GET_MODELOS_BY_MARCA(id).then(r => {
                    modelos.value = r.data
                })
            }
        }

        const filterMarcas = async () => {
            await GET_MARCAS_BY_SEGMENTO(props.loja.segmento_id).then(r => {
                marcas.value = r.data
            })
        }

        const filterComplementos = async () => {
            if (modelo.value === '') {
                complemento.value = ''
                complementos.value = []
            } else {
                const id = findId(modelos.value, modelo.value, 'descricao')
                await GET_COMPLEMENTOS_BY_MODELO(id).then(r => {
                    complementos.value = r.data
                })
            }
            complementos.value = complementos.value.filter(x => {
                if (!registeredProducts.value.some(n => n.complemento_id === x.id)) {
                    return x
                }
            })
        }

        const filteredListComplementos = computed(() => {
            
            if (modelo.value === '') {
                return []
            }
            if (searchComplemento.value !== '') {
                return complementos.value.filter(c => c.descricao.toLowerCase().includes(searchComplemento.value.toLowerCase()))
            }
            return complementos.value
        })

        const registeredProducts = ref([])
        const getRegisteredProducts = async () => {
            await GET_PRODUTOS_BY_LOJA(props.loja.id).then(r => {
                registeredProducts.value = r.data
            })
        }


        const addProduct = (c) => {
            const body = {
                loja_id: props.loja.id,
                faturamento_id: props.loja.faturamento_id,
                endereco_id: props.loja.endereco_id,
                segmento_id: props.loja.segmento_id,
                marca_id: findId(marcas.value, marca.value, 'marca'),
                modelo_id: findId(modelos.value, modelo.value, 'descricao'),
                complemento_id: c
            }
            POST_PRODUTOS_LOJA(body).then(async r => {
                displayNotification(r)
                await getRegisteredProducts()
                filterComplementos()
            }).catch(e => {
                displayNotification(e.response)
            })
        }

        const getLists = async () => {
            filterMarcas()
        }

        onMounted(async () => {
            await getLists()
            await getRegisteredProducts()
        })

        const rules = computed(() => {
            return {
                segmento:
                    { uincludes: (value) => segmentos.value.map(a => a.descricao).includes(value.value) }

            }
        })
        const v$ = useVuelidate(rules, { segmento })

        const createProduct = async (type) => {
            let request = null
            let body = {}
            if (type === 'segmento') {
                request = POST_SEGMENTOS
                body = {
                    descricao: segmento.value,
                    porcentagem: 20
                }
            } else if (type === 'marca') {
                request = POST_MARCAS
                body = {
                    segmento_id: findId(segmentos.value, segmento.value, 'descricao'),
                    marca: marca.value
                }
            } else if (type === 'modelo') {
                request = POST_MODELOS
                body = {
                    segmento_id: findId(segmentos.value, segmento.value, 'descricao'),
                    marca_id: findId(marcas.value, marca.value, 'marca'),
                    descricao: modelo.value
                }
            } else {
                request = POST_COMPLEMENTO
                body = {
                    segmento_id: findId(segmentos.value, segmento.value, 'descricao'),
                    marca_id: findId(marcas.value, marca.value, 'marca'),
                    modelo_id: findId(modelos.value, modelo.value, 'descricao'),
                    descricao: complemento.value
                }
            }
            await request(body).then(async (r) => {
                displayNotification(r)
                if (type === 'complemento') {
                    segmento.value = ''
                    marca.value = ''
                    modelo.value = ''
                    complemento.value = ''
                    v$.value.$reset()
                }
            }).catch(e => {
                displayNotification(e.response)
            })
            getLists()
        }
        return {
            segmentos,
            segmento,
            searchComplemento,
            marcas,
            marca,
            modelos,
            modelo,
            complemento,
            complementos,
            filterModelos,
            filterMarcas,
            filterComplementos,
            v$,
            createProduct,
            getLists,
            filteredListComplementos,
            addProduct
        }
    }
}
</script>
<style>
</style>
